<script lang="ts">
    import { mdiCalendarRemove, mdiCalendarPlus } from "@mdi/js"
    import { postFollowUp, putFollowUp, removeBookmark, removeFollowUp, toggleBookmark } from "../../api"
    import { followUpMap, bookmarks, login, newNotification } from "../../store"
    import { _ } from "svelte-i18n"
    import BookmarkIcon from "./BookmarkIcon.svelte"
    import Calendar from "./calendars/FollowUpCalendar.svelte"
    import { tooltip } from "../../helper"
    export let operation: Operation | OperationOut | FollowUpOperation | FollowUpOperationOut, personNumber: number

    let dateValue: Date = null,
        bookmarkBtn: HTMLButtonElement

    function checkIfUserIsOwnerOfFollowUp() {
        if ("attachedAccount" in operation)
            return $login.account.ident.personNumber === operation?.attachedAccount?.ident?.personNumber
        return personNumber === $login.account.ident.personNumber
    }
    function respawnElement(element: HTMLElement, deepCopy: boolean = true) {
        var newElement = element.cloneNode(deepCopy)
        element.parentNode.replaceChild(newElement, element)
        return newElement
    }

    function hideAllModals() {
        const dateModal = document.getElementById("dateModal")
        dateModal.style.display = "none"
        respawnElement(dateModal, false)
        const dateDeleteValidationModal = document.getElementById("dateDeleteValidationModal")
        dateDeleteValidationModal.style.display = "none"
        respawnElement(dateDeleteValidationModal)
        const followUpDeleteValidationModal = document.getElementById("followUpDeleteValidationModal")
        followUpDeleteValidationModal.style.display = "none"
        respawnElement(followUpDeleteValidationModal)
    }
    async function updateFollowUp(date: Date) {
        let followUpOp = $followUpMap[operation.collectionName][personNumber][operation.id]
        if (followUpOp?.date && new Date(date).getTime() === new Date(followUpOp.date).getTime()) return
        const newFollowUp = {
            ...(followUpOp || {}),
            date: date,
            dataId: operation.id,
            type: operation.collectionName,
            ident: $login.account.ident,
        }
        if (followUpOp?.id) {
            putFollowUp(newFollowUp).then((res) => {
                newNotification({
                    class: "success",
                    html: $_("notifications.resubmissionSuccessfullyUpdated"),
                })
                followUpOp = res.data
                $followUpMap[operation.collectionName][personNumber][operation.id] = followUpOp
            })
        } else {
            postFollowUp(newFollowUp).then((res) => {
                newNotification({
                    class: "success",
                    html: $_("notifications.resubmissionSuccessfullyCreated"),
                })
                followUpOp = res.data
                $followUpMap[operation.collectionName][personNumber][operation.id] = followUpOp
            })
        }
    }

    function getFollowUpState(date: Date): "none" | "today" | "overdue" | "future" {
        if (!date) return "none"

        const givenDate = new Date(date)
        const currentDate = new Date()
        const isToday =
            givenDate.getFullYear() === currentDate.getFullYear() &&
            givenDate.getMonth() === currentDate.getMonth() &&
            givenDate.getDate() === currentDate.getDate()

        if (isToday) return "today"
        else if (givenDate < currentDate) return "overdue"
        else return "future"
    }

    function setDateValue() {
        const followUpOp = $followUpMap[operation.collectionName]?.[personNumber]?.[operation.id]
        dateValue = followUpOp?.date ? new Date(followUpOp.date) : null
    }

    function getElementPosition(
        element: HTMLElement,
        options: {
            minSpace: number
            offsetAbove: number
        } = { minSpace: 150, offsetAbove: 75 }
    ): {
        x: string
        y: string
    } {
        const rect = element.getBoundingClientRect()
        const scrollTop = window.scrollY || window.pageYOffset
        const windowHeight = window.innerHeight
        const topBody = Number(document.body.style.top.split("px")[0])
        let top = rect.bottom + scrollTop + 5 - topBody

        // Check if there's the specified minimum visible space below the element
        if (windowHeight - rect.bottom < options.minSpace) {
            // Place the element above the current element with the specified offset
            top = rect.top + scrollTop - element.offsetHeight - options.offsetAbove - topBody
        }
        return {
            y: top + "px",
            x: window.innerWidth - rect.right - 20 + "px",
        }
    }

    function outSideFollowUpDeleteClickListener(e: MouseEvent) {
        const followUpDeleteValidationModal = document.getElementById("followUpDeleteValidationModal")
        if (!followUpDeleteValidationModal.contains(e.currentTarget as Node)) hideFollowUpDeleteValidationModal()
    }

    function hideFollowUpDeleteValidationModal() {
        const followUpDeleteValidationModal = document.getElementById("followUpDeleteValidationModal")
        followUpDeleteValidationModal.style.display = "none"
        const bottom = followUpDeleteValidationModal.querySelector(".bottom")
        bottom.removeEventListener("click", followUpShutdownListener)
        document.removeEventListener("click", outSideFollowUpDeleteClickListener)
    }
    function followUpShutdownListener(e: any) {
        if ((e.target as HTMLElement).classList.contains("delete")) {
            removeBookmark(operation.collectionName, operation.id)
            if ($followUpMap[operation.collectionName]?.[personNumber]?.[operation.id]?.id)
                removeFollowUp(operation.collectionName, operation.id)
            dateValue = null
            isBookmarked = false
        }
        hideFollowUpDeleteValidationModal()
    }
    function approveFollowUpShutdown() {
        const followUpDeleteValidationModal = document.getElementById("followUpDeleteValidationModal")
        followUpDeleteValidationModal.style.display = "flex"
        const bottom = followUpDeleteValidationModal.querySelector(".bottom")
        followUpDeleteValidationModal.style.top = getElementPosition(bookmarkBtn).y
        followUpDeleteValidationModal.style.right = getElementPosition(bookmarkBtn).x
        bottom.addEventListener("click", followUpShutdownListener)
        document.addEventListener("click", outSideFollowUpDeleteClickListener)
    }
    $: if (!checkIfUserIsOwnerOfFollowUp())
        if ("attachedAccount" in operation) personNumber = operation.attachedAccount.ident.personNumber
    $: if (!!$followUpMap?.[operation?.collectionName]?.[personNumber]) setDateValue()
    $: followUpState = getFollowUpState(dateValue)
    $: isBookmarked = !!$bookmarks?.[operation.collectionName]?.[personNumber]?.[operation.id]
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<!-- svelte-ignore a11y-click-events-have-key-events -->
<style lang="less">
    .wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: default;
        .follow-up {
            padding: 2px 6px 2px 2px;
            border-style: solid;
            height: 34px;
            min-width: 148px;
            border-radius: 200px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            position: relative;
            &.isNotOwner {
                pointer-events: none;
                opacity: 0.5;
            }
            button.bookmark {
                height: 24px;
                width: 24px;
                &::before {
                    display: none;
                }
                &::after {
                    display: none;
                }
                padding: 0px;

                margin-right: 6px;
                color: var(--renzrot);
                :global span {
                    height: 24px;
                    width: 24px;
                }
            }
            p {
                padding: 0px;
                margin: 0px;
                font-size: 16px;
                cursor: default;
            }
            .custom-date-picker {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;
                gap: 12px;
                flex-grow: 1;

                .calendar-icon {
                    flex-grow: 1;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                }
            }

            &.none {
                border: 2px solid #464646;
            }
            &.future,
            &.today,
            &.overdue {
                border: 2px solid var(--renzrot);
                &.overdue {
                    background-color: var(--renzrot);
                    color: white;
                    &:global svg {
                        color: white;
                    }
                }
            }
        }
    }
</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
    class="wrapper"
    use:tooltip="{!checkIfUserIsOwnerOfFollowUp()
        ? {
              content: $_('components.followUp.onlyEditResubmissions'),
          }
        : false}"
>
    <div
        class="follow-up {followUpState}"
        on:click|stopPropagation
        class:isNotOwner="{!checkIfUserIsOwnerOfFollowUp()}"
    >
        <button
            bind:this="{bookmarkBtn}"
            class="btn bookmark {isBookmarked ? 'isBookmarked' : ''}"
            data-cy="bookmark-button"
            on:click|stopPropagation="{() => {
                hideAllModals()
                if (isBookmarked) approveFollowUpShutdown()
                else toggleBookmark(operation.collectionName, operation.id)
            }}"
        >
            <BookmarkIcon {operation} label="" forceNotBookmarkedIcon="{followUpState === 'overdue'}" />
        </button>
        {#if !dateValue}
            <p>
                {#if followUpState == "none" && !isBookmarked}
                    {$_("general.note")}
                {:else if followUpState == "none" && isBookmarked}
                    {$_("general.noted")}
                {/if}
            </p>
        {/if}
        {#key dateValue}
            {#if isBookmarked}
                {#if !dateValue}
                    <Calendar
                        {followUpState}
                        symbol="{mdiCalendarPlus}"
                        dateValue="{null}"
                        {hideAllModals}
                        {getElementPosition}
                        on:update="{(e) => {
                            if (e.detail) updateFollowUp(e.detail)
                        }}"
                        tooltipContent="{$_('components.followUp.setResubmissionDate')}"
                    />
                {:else}
                    <Calendar
                        {followUpState}
                        on:update="{(e) => {
                            if (!e.detail) {
                                removeFollowUp(operation.collectionName, operation.id).then(() => {
                                    dateValue = null
                                })
                            } else updateFollowUp(e.detail)
                        }}"
                        {getElementPosition}
                        {hideAllModals}
                        symbol="{mdiCalendarRemove}"
                        dateValue="{new Date(dateValue)}"
                        tooltipContent="{$_('components.followUp.removeResubmissionDate')}"
                    />
                {/if}
            {/if}
        {/key}
    </div>
</div>
